import {
  taskOutcomeFieldAppliesTo,
  validateTaskOutcomeData,
  type TaskOutcomeContract,
} from '@erp/shared-types';
import { taskCloseInput } from './taskPlaybookGate';
export function outcomeCloseIsBlocked(
  contract: TaskOutcomeContract | null | undefined,
  cancelling: boolean,
  outcome: string,
  reason: string,
): boolean {
  if (!contract) return true;
  if (!cancelling && contract.outcomeRequired && !outcome) return true;
  return contract.fields.length > 0 && !reason.trim();
}
export function buildOutcomeCloseInput(
  id: string,
  contract: TaskOutcomeContract,
  cancelling: boolean,
  outcome: string,
  reason: string,
  values: Record<string, unknown>,
) {
  const input = {
    ...taskCloseInput(id, cancelling ? '' : outcome, reason),
    outcomeContractFingerprint: contract.fingerprint,
  };
  if (cancelling || contract.fields.length === 0) return input;
  // Values typed before switching outcome belong to fields no longer shown.
  const shown = Object.fromEntries(
    contract.fields.flatMap((field) =>
      taskOutcomeFieldAppliesTo(field, outcome)
        ? [[field.key, values[field.key]]]
        : [],
    ),
  );
  const checked = validateTaskOutcomeData(contract.fields, outcome, shown);
  if (!checked.success)
    throw new Error(
      checked.issues
        .map((issue) => `${issue.path}: ${issue.message}`)
        .join('; '),
    );
  return { ...input, outcomeData: checked.data };
}

export function outcomeReasonRequired(
  contract: TaskOutcomeContract | null | undefined,
  status: string,
): boolean {
  return Boolean(contract?.fields.length) || status === 'needs_input';
}

export function isReasonOnlyCancellation(
  contract: TaskOutcomeContract | null | undefined,
  kind: string | null,
): boolean {
  return kind === 'cancel' && Boolean(contract?.fields.length);
}
